import Constants from '../constants';
import produce from "immer";
import { UpdateArray, UpdateArrayRange } from '../misc/ArrayFuncs';
const roundToTwo = (num) => {
    return +(Math.round(num + "e+2") + "e-2");
}
const initDataState = [];
const HeatVesselTemps = (state = initDataState, action) => {
    switch (action.type) {
        case Constants.Actions.HeatVesselTemp.Add:
            return UpdateArray(action.payload, state);
        case Constants.Actions.HeatVesselTemp.Add_Rollback:
            const ivId = state.findIndex(iv => iv.id === action.meta.newHVTemp.id);
            if (ivId !== -1) {
                return produce(state, pd => { pd.splice(ivId, 1) });
            } else {
                return state;
            }
        case Constants.Actions.HeatVesselTemp.Add_Commit:
            return UpdateArray(action.payload?.data, state);
        case Constants.Actions.HeatVesselTemp.ClearData:
            return initDataState;
        case Constants.Actions.HeatVesselTemp.Update:
            return UpdateArray(action.payload.update, state);
        case Constants.Actions.HeatVesselTemp.Update_Commit:
            return UpdateArray(action.payload?.data, state);
        case Constants.Actions.HeatVesselTemp.Update_Rollback:
            return UpdateArray(action.meta.data.current, state);
        case Constants.Actions.HeatVesselTemp.GetByParentID:
            return UpdateArrayRange(action.data, state);
        default:
            return state;
    }
}
export default HeatVesselTemps;